module.exports = __webpack_public_path__ + "Player1Wins.mp3";